angular.module('com.vmware.vsphere.client.host').service('hostVuiService', ['vuiWizardService', function (vuiWizardService) {
   return {
      createWizard: vuiWizardService
   };
}]);
